import { connect, useDispatch } from 'react-redux';
import * as $ from 'jquery';
import { currentStoreLoad, storeStaffsLoad } from '../../../redux/actions/currentStoreActions';
import { procedurePricingsLoad } from '../../../redux/actions/storeSettings/ProcedurePricingActions';
import { examEdit, examLoad } from '../../../redux/actions/exam/examActions';
import { patientMedicalHistoriesLoad } from '../../../redux/actions/patient/patientMedicalHistoryActions';
import { patientReportsLoad } from '../../../itrust_common/redux/actions/settingActions/patientReportActions';
import { handleStartExamRecording } from '../exam/CommonFunctions';

export default function EditExamButton(props) {
  const { examId, storeId, children } = props;
  const dispatch = useDispatch()

  const loadStoreDependencies = (storeId) => {
    let localStorageStoreId = localStorage.getItem('StoreID')
    if (!localStorageStoreId) {
      dispatch(currentStoreLoad())
      // this.props.dispatch(storeStaffsLoad(storeId,{ rpp: 1000, filter: { doctor: storeId }}))
      dispatch(procedurePricingsLoad({ rpp: 99999, filter: { for_store: storeId }, include: ['procedures'] }))
    }
    if ((localStorageStoreId && localStorageStoreId != 'null') || storeId) {
      // Inactive staffs cases
      dispatch(storeStaffsLoad(localStorageStoreId || storeId, { rpp: 1000, filter: { doctor: localStorageStoreId } }))
    }
  }

  const handleExamEdit = async (storeId, id) => {
    loadStoreDependencies(storeId)
    dispatch(examEdit(id))
    let res = await dispatch(examLoad(id, { include: '*' }))
    res = res.value.data.exam
    res.is_telemed && handleStartExamRecording()
    //Medical history for overview
    dispatch(patientMedicalHistoriesLoad(res.patient_id, { rpp: 500, exam_id: res.id }));
    //Prescription report template
    dispatch(patientReportsLoad({ patient_id: res.patient_id, staff_id: res.staff_id, store_id: res.store_id, filter: { category: ["medical_rx", "referral"] } }))
    setTimeout(function () {
      $('#orderForm-modal').modal('hide');
      $('#editExamForm-modal').modal('show');
    }, 1000)
  }

  return (
    <span
      className="pointer"
      onClick={() => handleExamEdit(storeId, examId)}
    >
      {children}
    </span>
  )
}
